import { render, staticRenderFns } from "./_pkEdit.vue?vue&type=template&id=1b8e20ff&"
import script from "./_pkEdit.vue?vue&type=script&lang=js&"
export * from "./_pkEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./_pkEdit.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports